/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cna_Field_Call_Time_HelpInputs */

const en_cna_field_call_time_help = /** @type {(inputs: Cna_Field_Call_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`When you made the (last) call attempt.`)
};

const ja_cna_field_call_time_help = /** @type {(inputs: Cna_Field_Call_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`（最後の）発信を行った時刻。`)
};

const fr_cna_field_call_time_help = /** @type {(inputs: Cna_Field_Call_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quand vous avez effectué la (dernière) tentative d'appel.`)
};

const de_cna_field_call_time_help = /** @type {(inputs: Cna_Field_Call_Time_HelpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wann Sie den (letzten) Anrufversuch unternommen haben.`)
};

/**
* | output |
* | --- |
* | "When you made the (last) call attempt." |
*
* @param {Cna_Field_Call_Time_HelpInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const cna_field_call_time_help = /** @type {((inputs?: Cna_Field_Call_Time_HelpInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cna_Field_Call_Time_HelpInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_cna_field_call_time_help(inputs)
	if (locale === "ja") return ja_cna_field_call_time_help(inputs)
	if (locale === "fr") return fr_cna_field_call_time_help(inputs)
	return de_cna_field_call_time_help(inputs)
});